export enum Thresholds {
  HIGH = -20,
  MIDDLE = 0,
  LOW = 10,
}
